import { createSelector } from 'reselect';
import * as fromCore from '../../core/reducers';
import * as fromAircraftCategoryCollection from '../reducers/aircraft-category-collection';

export const getAircraftCategoryCollectionState = createSelector(
  fromCore.getCoreState,
  (state) => state[fromAircraftCategoryCollection.aircraftCategoriesFeatureKey]
);
export const getAircraftCategoryCollectionLoaded = createSelector(
  getAircraftCategoryCollectionState,
  fromAircraftCategoryCollection.getLoaded
);
export const getAircraftCategoryCollectionLoading = createSelector(
  getAircraftCategoryCollectionState,
  fromAircraftCategoryCollection.getLoading
);
export const getAircraftCategoryCollection = createSelector(
  getAircraftCategoryCollectionState,
  fromAircraftCategoryCollection.getItems
);
